const RETURN_PATH_KEY = "tnn.auth.returnPath";

function isAuthPath(path: string): boolean {
  return (
    path === "/login" ||
    path.startsWith("/login?") ||
    path.startsWith("/forgot-password") ||
    path.startsWith("/reset-password") ||
    path.startsWith("/accept-invite")
  );
}

/** Persist the in-app path so login can restore it after JWT expiry. */
export function stashReturnPath(path: string): void {
  if (typeof window === "undefined") return;
  const trimmed = path || "/";
  if (isAuthPath(trimmed)) return;
  try {
    sessionStorage.setItem(RETURN_PATH_KEY, trimmed);
  } catch {
    // sessionStorage may be unavailable.
  }
}

export function consumeReturnPath(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const value = sessionStorage.getItem(RETURN_PATH_KEY);
    sessionStorage.removeItem(RETURN_PATH_KEY);
    if (!value || isAuthPath(value)) return null;
    return value;
  } catch {
    return null;
  }
}

export function currentAppPath(): string {
  if (typeof window === "undefined") return "/";
  const pathname = window.location.pathname;
  const match = pathname.match(/^\/o\/[^/]+(\/.*)?$/);
  const rest = match ? match[1] || "/" : pathname;
  return `${rest}${window.location.search}` || "/";
}
